export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abrir disputa"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Um moderador se juntará para ajudar. Por favor, selecione um motivo e anexe evidências."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar ao moderador"])}
}